import "pfkl-vselect/vselect/vselect.min.js";

import Highcharts, { color } from "highcharts";
import treemap from "highcharts/modules/treemap";
import accessibility from "highcharts/modules/accessibility";
accessibility(Highcharts);

import {
  modMap,
  markerStyle,
  regionStyle,
  getValidCountryCodes,
  countryCodeFound,
  getCountryObjectByCode,
  // getSpanishCountryName,
  appendMapTooltip,
} from "./js/helper";

import "./supercycle-arc";
import "./supercycle-tiny-human";

jQuery(function ($) {
  console.log("Super Cycle ready");

  // World map
  if ($("#supercycle-worldmap").length > 0) {
    var theMap = $("#supercycle-worldmap");
    const tipHover = $(".map-tooltip-hover"); // For hover type tooltip
    const markerOverlay = $("#marker-overlay");
    const pageLang = theMap.data("pagelang");
    const mapData = theMap.data("countries");
    const markerData = theMap.data("markers");

    const combinedData = mapData.concat(markerData);
    // Sort the combinedData alphabetically based on the 'name' property of each object
    combinedData.sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      if (nameA < nameB) return -1;
      if (nameA > nameB) return 1;
      return 0;
    });

    // console.log('mapData', mapData);
    // console.log('markerData', markerData);

    theMap.vectorMap({
      map: "world_mill",
      backgroundColor: "#FFFFFF00",
      panOnDrag: true,
      zoomAnimate: true,
      zoomOnScroll: false,
      markers: markerData,
      markerStyle: {
        initial: {
          stroke: "#E3E6EB",
          r: 10,
          "stroke-width": 5,
        },
      },
      focusOn: {
        x: 0.5,
        y: 0.5,
        scale: 1,
      },
      regionStyle: { ...regionStyle, initial: { fill: "#E3E6EB" } },
      onRegionClick: function (e, code) {
        // REGION CLICK
        e.preventDefault();

        if (countryCodeFound(mapData, code)) {
          const countryObj = getCountryObjectByCode(mapData, code);
          console.log("countryObj", countryObj);

          beforeGetCountryPanel(countryObj.tid);
        }

        return false;
      },
      onRegionOver: function (e, code) {
        // REGION HOVER
        e.preventDefault();

        onHover(e, code, mapData);

        return false;
      },
      onRegionOut: function (e, code) {
        // REGION OUT
        e.preventDefault();

        tipHover.hide();
        e.target.removeEventListener("mousemove", tooltipMousemove);
      },
      onRegionTipShow: function (e) {
        e.preventDefault();

        return false;
      },
      onViewportChange: function (e, scale) {
        // console.log('onViewportChange', e.target, 'scale', scale);
      },
      onMarkerTipShow: function (e, label, index) {
        // console.log('e label index', e, label, index);
        e.preventDefault();
      },
      onMarkerClick: function (e, index) {
        // MARKER CLICK
        e.preventDefault();

        beforeGetCountryPanel(markerData[index].tid);
      },
      onMarkerOver: function (e, index) {
        // MARKER HOVER
        e.preventDefault();

        onHover(e, markerData[index].country_code, markerData);
      },
      onMarkerOut: function (e, index) {
        // MARKER OUT
        e.preventDefault();

        tipHover.hide();
        e.target.removeEventListener("mousemove", tooltipMousemove);
      },
    });
    // theMap.vectormap END ///////////////////////

    modMap(theMap, "#E3E6EB");
    var myMap = theMap.vectorMap("get", "mapObject");

    function getStateColor(state) {
      switch (state) {
        case "upcoming":
          return "#1570B1";

        case "past":
          return "#95C2E5";

        default:
          return "#C1C7D3";
      }
    }

    // Position map tooltip
    function tooltipMousemove(e) {
      let top = window.pageYOffset || document.documentElement.scrollTop;

      tipHover.css("top", e.pageY - top + "px");
      tipHover.css("left", e.pageX + "px");
    }

    function onHover(e, code, data) {
      if (countryCodeFound(data, code)) {
        const countryObj = getCountryObjectByCode(data, code);

        let content = {};
        let datey;

        // if (pageLang === "es") {
        //   let esName = getSpanishCountryName(code);
        //   if (esName === "") {
        //     esName = countryObj.name;
        //   }

        if (countryObj.election_date == null) {
          datey = "TBD";
        } else {
          datey = countryObj.election_date;
        }

        //   content.title = "<strong>" + esName + "</strong><br/>" + '<span style="font-weight: normal">Fecha de las elecciones: ' + countryObj.election_date + "</span>";
        //   content.footer = '<div class="text-ideaCyanSignal mt-4">(Haz clic para ver el análisis más reciente de las elecciones)</div>';
        // } else {
        content.title =
          "<strong>" +
          countryObj.name +
          "</strong><br/>" +
          '<span style="font-weight: normal">Election date: ' +
          datey +
          "</span>";
        // content.footer = '<div class="text-ideaCyanSignal mt-4">View country panel</div>';
        // content.title = "<strong>" + countryObj.name + "</strong>";
        content.footer = '<div class="mt-4">(Click to view more)</div>';
        // }

        content.body = [];

        appendMapTooltip(tipHover, content);
        tipHover.css("position", "fixed");
        tipHover.show();

        e.target.addEventListener("mousemove", tooltipMousemove);
      }
    }

    // Map init
    function initMap() {
      const validCountryCodes = getValidCountryCodes(myMap, mapData);

      validCountryCodes.map((country, index) => {
        const color = getStateColor(country.state);

        myMap.regions[country.country_code].element.setStyle("fill", color);

        theMap
          .find('path[data-code="' + country.country_code + '"]')
          .addClass("selected");
      });
    }

    initMap();

    $(".jvectormap-zoomin").appendTo($(".supercycle-map-zooms"));
    $(".jvectormap-zoomout").appendTo($(".supercycle-map-zooms"));
    $(".jvectormap-zoomin").text("Zoom in");
    $(".jvectormap-zoomout").text("Zoom out");

    setTimeout(() => {
      var svgimg = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "image"
      );
      svgimg.setAttributeNS(null, "height", "50");
      svgimg.setAttributeNS(null, "width", "50");
      svgimg.setAttributeNS(
        "http://www.w3.org/1999/xlink",
        "href",
        "/themes/custom/tema/src/assets/supercycle/marker-europe.svg"
      );
      svgimg.setAttributeNS(null, "x", "365");
      svgimg.setAttributeNS(null, "y", "130");
      svgimg.setAttributeNS(null, "visibility", "visible");
      svgimg.setAttributeNS(null, "id", "supercycle-europe-marker");
      svgimg.setAttributeNS(null, "class", "cursor-pointer hover:opacity-60");
      $("#supercycle-worldmap svg g:first-of-type").append(svgimg);

      $("#supercycle-europe-marker").on("click", function () {
        beforeGetCountryPanel("europe");
      });

      const $progress = $(".progress-value-compulsory");

      const targetValue = $progress.data("value");

      $progress.animate({ width: `${targetValue}%` }, 2000, "swing");
    }, 1000);

    function beforeGetCountryPanel(tid) {
      // If a country panel already opened
      if ($(".modal-country-panel").length > 0) {
        $(".modal-country-panel").addClass("translate-x-full");

        setTimeout(() => {
          $(".modal-country-panel").remove();
          getCountryPanel(tid);
        }, 300);
      } else {
        getCountryPanel(tid);
      }
    }

    // Function to call API to get country data
    function getCountryPanel(tid) {
      $("#fake-loading").fadeIn();

      // console.log('tid', tid);

      const data = { tid };

      const settings = {
        url: "/api/supercycle/country",
        data: JSON.stringify(data),
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/json",
        },
        error: function (error) {
          $("#fake-loading").fadeOut();
          console.log("error", error);
        },
      };

      $.ajax(settings).done(function (response) {
        $("#fake-loading").fadeOut();
        // console.log('response', response.html);
        // console.log('response', JSON.parse(response.gsodIndicesData));

        const countryPanelHtml = response.html;

        $("body").append(countryPanelHtml);

        setTimeout(() => {
          $(".modal-country-panel").removeClass("translate-x-full");

          if ($(".modal-country-panel").find(".supercycle-arc").length > 0) {
            $(".modal-country-panel")
              .find(".supercycle-arc")
              .each(function () {
                const elm = $(this);
                const percentage = elm.data("percentage");
                const duration = 120; // 60 fps, 2 seconds, no fps corrected, GG for 30 fps monitor.

                let countUp = 0;
                let elapsed = 0;
                let deg = 0;

                function animateCountUp() {
                  elapsed++;

                  countUp = Math.ceil(percentage * (elapsed / duration));
                  deg = Math.ceil(
                    360 * (percentage / 100) * (elapsed / duration)
                  );

                  const xy = calculatePointOnCircle(60, 60, 57, deg);
                  const flag = deg <= 180 ? 0 : 1;

                  elm
                    .find(".supercycle-arc--percentage span")
                    .text(countUp + "%");
                  elm
                    .find("svg path:nth-child(2)")
                    .attr(
                      "d",
                      "M 117,60 A 57,57 0 " + flag + ",1 " + xy.x + "," + xy.y
                    );

                  if (elapsed < duration) {
                    // Stop the animation after 2 seconds
                    window.requestAnimationFrame(animateCountUp);
                  }
                }

                window.requestAnimationFrame(animateCountUp);
              });
          }

          if ($(".modal-country-panel").find(".gsod-mappy").length > 0) {
            $(".modal-country-panel")
              .find(".gsod-mappy")
              .each(function () {
                var gsodMappyElement = document.querySelector(".gsod-mappy");
                var countryName =
                  gsodMappyElement.getAttribute("data-countryName");

                var newDiv = $("<div>").attr("id", "gsod-mappy-" + tid);
                $(this).append(newDiv);

                const indicesData = JSON.parse(response.gsodIndicesData);
                var countryData = [];
                var worldData = [];

                // Filter data for the specified years
                var filteredData = indicesData.data.filter(function (item) {
                  return ["2002", "2007", "2012", "2017", "2022"].includes(
                    item.year
                  );
                });

                filteredData.forEach(function (item) {
                  if (item.country_name === countryName) {
                    countryData.push(item);
                  } else if (item.country_name === "World") {
                    worldData.push(item);
                  }
                });

                // Extract years for xAxis categories
                var categories = countryData.map(function (item) {
                  return item.year;
                });

                // Extract Credible Elections and Free Political Parties data for each country
                var countryCredibleElections = countryData.map(function (item) {
                  return item["Credible Elections"];
                });

                var worldCredibleElections = worldData.map(function (item) {
                  return item["Credible Elections"];
                });

                var countryFreePoliticalParties = countryData.map(function (
                  item
                ) {
                  return item["Free Political Parties"];
                });

                var worldFreePoliticalParties = worldData.map(function (item) {
                  return item["Free Political Parties"];
                });

                new Highcharts.Chart({
                  chart: {
                    renderTo: "gsod-mappy-" + tid,
                    marginBottom: 80,
                    backgroundColor: "#F9F9FB",
                  },
                  title: { text: "" },
                  legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "bottom",
                    itemWidth: 200,
                    symbolWidth: 18,
                    symbolHeight: 10,
                    margin: 0, // Set margin to 0 to ensure no additional space is added
                    y: 20, // Adjust the vertical position of the legend to create bottom padding
                  },
                  xAxis: {
                    categories: categories,
                    labels: {
                      rotation: 0,
                    },
                    lineWidth: 1,
                    lineColor: "#E5E7E9",
                  },
                  yAxis: {
                    gridLineWidth: 0,
                    tickPositions: [0, 0.2, 0.4, 0.6, 0.8, 1.0],
                    title: {
                      text: "",
                    },
                    lineWidth: 1,
                    lineColor: "#E5E7E9",
                  },
                  series: [
                    {
                      name: "Free Political Parties",
                      data: countryFreePoliticalParties,
                      color: "#50C3DE",
                      type: "spline",
                      marker: {
                        enabled: false,
                      },
                    },
                    {
                      name: "Credible Elections",
                      data: countryCredibleElections,
                      color: "#F38336",
                      type: "spline",
                      marker: {
                        enabled: false,
                      },
                    },
                    {
                      name: "Global average",
                      data: worldFreePoliticalParties,
                      dashStyle: "longdash",
                      color: "#50C3DE",
                      type: "spline",
                      marker: {
                        enabled: false,
                      },
                    },
                    {
                      name: "Global average",
                      data: worldCredibleElections,
                      dashStyle: "longdash",
                      color: "#F38336",
                      type: "spline",
                      marker: {
                        enabled: false,
                      },
                    },
                  ],
                });
              });
          }
        }, 100);

        $("#close-supercycle-country-panel").on("click", function () {
          $(".modal-country-panel").addClass("translate-x-full");
          setTimeout(() => {
            $(".modal-country-panel").remove();
          }, 300);
        });

        // Close the modal when clicking outside of it
        $(document).on("click", function (e) {
          if (!$(e.target).closest(".modal-country-panel").length) {
            $(".modal-country-panel").addClass("translate-x-full");
            setTimeout(() => {
              $(".modal-country-panel").remove();
            }, 300);
          }
        });
      });
    }
    // getCountryPanel END ////////////////

    $("#countries-select").vSelect({
      multiSelect: false,
      placeholder: "Select country",
      display: "values",
      onChange: function (values, options) {
        // console.log('values', values);
        // console.log('options', options);

        beforeGetCountryPanel(values.value);

        // !!! Previously was opening analysis link !!!
        // window.open(values.value, '_blank');
      },
    });

    // List view for map data
    const tableBody = document.querySelector(".viewall-table-body");

    combinedData.forEach((item) => {
      const { name, election_dates } = item;

      election_dates.forEach((item) => {
        const election_date = item.date;
        const election_rawdate = item.rawDate;
        const election_type = item.type;

        const row = document.createElement("tr");

        const nameCell = document.createElement("td");
        nameCell.textContent = name;
        nameCell.classList.add("country-cell");
        row.appendChild(nameCell);

        const typeCell = document.createElement("td");
        typeCell.textContent = election_type;
        typeCell.classList.add("type-cell");
        row.appendChild(typeCell);

        let formattedDate;

        if (election_date == null || election_date == "TBD") {
          formattedDate = "TBD";
        } else {
          if (election_date.indexOf("-") > 0) {
            const electionDates = election_date.split(" - ");
            const date = new Date(electionDates[0]);
            const endDate = new Date(electionDates[1]);
            formattedDate =
              date.getDate() +
              " " +
              date.toLocaleString("en-US", { month: "long" });
            formattedDate +=
              " - " +
              endDate.getDate() +
              " " +
              endDate.toLocaleString("en-US", { month: "long" });
          } else {
            const date = new Date(election_date);
            formattedDate =
              date.getDate() +
              " " +
              date.toLocaleString("en-US", { month: "long" });
          }
        }

        const dateCell = document.createElement("td");
        dateCell.textContent = formattedDate;
        dateCell.classList.add("date-cell");
        row.appendChild(dateCell);

        const rawDateCell = document.createElement("td");
        rawDateCell.textContent =
          election_rawdate === null ? "TBD" : election_rawdate;
        rawDateCell.classList.add("rawdate-cell");
        rawDateCell.classList.add("hidden");
        row.appendChild(rawDateCell);

        tableBody.appendChild(row);
      });

      // const { name, election_type, election_date, election_rawdate } = item;
      // const row = document.createElement('tr');

      // const nameCell = document.createElement('td');
      // nameCell.textContent = name;
      // nameCell.classList.add('country-cell');
      // row.appendChild(nameCell);

      // const typeCell = document.createElement('td');
      // typeCell.textContent = election_type;
      // typeCell.classList.add('type-cell');
      // row.appendChild(typeCell);

      // let formattedDate;

      // if (election_date == null) {
      //   formattedDate = "TBD";
      // } else {
      //   if (election_date.indexOf('-') > 0) {
      //     const electionDates = election_date.split(' - ');
      //     const date = new Date(electionDates[0]);
      //     const endDate = new Date(electionDates[1]);
      //     formattedDate = date.getDate() + " " + date.toLocaleString('en-US', { month: 'long' });
      //     formattedDate += ' - ' + endDate.getDate() + " " + endDate.toLocaleString('en-US', { month: 'long' });
      //   } else {
      //     const date = new Date(election_date);
      //     formattedDate = date.getDate() + " " + date.toLocaleString('en-US', { month: 'long' });
      //   }
      // }

      // const dateCell = document.createElement('td');
      // dateCell.textContent = formattedDate;
      // dateCell.classList.add('date-cell');
      // row.appendChild(dateCell);

      // const rawDateCell = document.createElement('td');
      // rawDateCell.textContent = election_rawdate === null ? 'TBD' : election_rawdate;
      // rawDateCell.classList.add('rawdate-cell');
      // rawDateCell.classList.add('hidden');
      // row.appendChild(rawDateCell);

      // tableBody.appendChild(row);
    });

    //List view toggle sort for country and date
    let sortOrderCountry = "desc";
    let sortOrderDate = "asc";
    let sortOrderDateRaw = "asc";

    $(document).on("click", ".viewall-table-head .country-first", function () {
      const rows = Array.from(
        document.querySelectorAll(".viewall-table-body tr")
      );
      const sortedRows = rows.sort((a, b) => {
        const countryA = a.cells[0].textContent.toLowerCase();
        const countryB = b.cells[0].textContent.toLowerCase();
        if (sortOrderCountry === "desc") {
          return countryA < countryB ? 1 : -1;
        } else {
          return countryA > countryB ? 1 : -1;
        }
      });

      const tableBody = document.querySelector(".viewall-table-body");
      sortedRows.forEach((row) => {
        tableBody.appendChild(row);
      });

      sortOrderCountry = sortOrderCountry === "desc" ? "asc" : "desc";
    });

    $(document).on("click", ".viewall-table-head .date-last", function () {
      const rowsDate = Array.from(
        document.querySelectorAll(".viewall-table-body tr")
      );
      const sortedRowsDate = rowsDate.sort((a, b) => {
        const dateA = getDateValue(a.cells[2].textContent);
        const dateB = getDateValue(b.cells[2].textContent);
        return sortOrderDate === "asc" ? dateA - dateB : dateB - dateA;
      });

      const tableBodyDate = document.querySelector(".viewall-table-body");
      sortedRowsDate.forEach((rowDate) => {
        tableBodyDate.appendChild(rowDate);
      });

      sortOrderDate = sortOrderDate === "asc" ? "desc" : "asc";
    });

    $(document).on("click", ".viewall-table-head .date-raw", function () {
      const rowsDate = Array.from(
        document.querySelectorAll(".viewall-table-body tr")
      );
      const sortedRowsDateRaw = rowsDate.sort((a, b) => {
        const dateA = a.cells[3].textContent;
        const dateB = b.cells[3].textContent;

        if (sortOrderDateRaw === "desc") {
          return dateA < dateB ? 1 : -1;
        } else {
          return dateA > dateB ? 1 : -1;
        }

        // return sortOrderDateRaw === 'asc' ? dateA - dateB : dateB - dateA;
      });

      const tableBodyDate = document.querySelector(".viewall-table-body");
      sortedRowsDateRaw.forEach((rowDate) => {
        tableBodyDate.appendChild(rowDate);
      });

      sortOrderDateRaw = sortOrderDateRaw === "asc" ? "desc" : "asc";
    });

    function getDateValue(dateString) {
      if (dateString === "TBD") {
        return new Date(new Date().getFullYear(), 11, 32);
      } else {
        const parts = dateString.split(" ");
        if (parts.length === 2) {
          const day = parseInt(parts[0], 10);
          const monthName = parts[1];
          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const month = monthNames.indexOf(monthName);
          if (day > 0 && month >= 0) {
            return new Date(new Date().getFullYear(), month, day);
          }
        }
        return new Date("Invalid Date");
      }
    }
  }
  // Map END //////////////////////////////////////////////////////////////////////////

  // Ring chart
  function calculatePointOnCircle(centerX, centerY, radius, angleDegrees) {
    // Convert angle from degrees to radians
    var angleRadians = (angleDegrees * Math.PI) / 180;

    // Calculate coordinates
    var x = centerX + radius * Math.cos(angleRadians);
    var y = centerY + radius * Math.sin(angleRadians);

    return { x: x, y: y };
  }

  if ($(".supercycle-arc").length > 0) {
    var win = $(window);

    win.on("scroll", function () {
      var winHeight = win.height();
      var scrolled = win.scrollTop();
      var windowPercentage = winHeight * 0.9;

      $(".supercycle-arc-wrapper").each(function () {
        var wrapper = $(this);
        var offsetTop = wrapper.offset().top;

        if (
          (scrolled + windowPercentage > offsetTop || winHeight > offsetTop) &&
          !wrapper.hasClass("animated") &&
          !wrapper.hasClass("no-scroll")
        ) {
          wrapper.addClass("animated");

          animateCircle();
        }
      });
    });

    $(".supercycle-arc-wrapper.no-scroll").each(function () {
      animateCircle();
    });
  }

  function animateCircle() {
    $(".supercycle-arc").each(function () {
      const elm = $(this);
      const percentage = elm.data("percentage");
      const duration = 120; // 60 fps, 2 seconds, no fps corrected, GG for 30 fps monitor.

      let countUp = 0;
      let elapsed = 0;
      let deg = 0;

      function animateCountUp() {
        elapsed++;

        countUp = Math.ceil(percentage * (elapsed / duration));
        deg = Math.ceil(360 * (percentage / 100) * (elapsed / duration));

        const xy = calculatePointOnCircle(60, 60, 57, deg);
        const flag = deg <= 180 ? 0 : 1;

        elm.find(".supercycle-arc--percentage span").text(countUp + "%");
        elm
          .find("svg path:nth-child(2)")
          .attr("d", "M 117,60 A 57,57 0 " + flag + ",1 " + xy.x + "," + xy.y);

        if (elapsed < duration) {
          // Stop the animation after 2 seconds
          window.requestAnimationFrame(animateCountUp);
        }
      }

      window.requestAnimationFrame(animateCountUp);
    });
  }
  // Ring chart END //////////////////////////////////////////////////////////////////////////

  // COUNT UP ANIMATION //////////////////////////////////////////////////////////////////////////

  // How long you want the animation to take, in ms
  const animationDuration = 2500;
  // Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
  const frameDuration = 200 / 60;
  const totalFrames = Math.round(animationDuration / frameDuration);
  const easeOutQuad = (t) => t * (2 - t);

  // The animation function, which takes an Element
  const animateCountUp = (el) => {
    let frame = 0;
    const countTo = parseInt(
      el.getAttribute("data-countup").replace(/,/g, ""),
      10
    );
    const initialCount = parseInt(el.innerHTML.replace(/,/g, ""), 10);

    const countDifference = countTo - initialCount;
    const counter = setInterval(() => {
      frame++;
      const progress = easeOutQuad(frame / totalFrames);
      const currentCount = Math.round(
        initialCount + countDifference * progress
      );

      if (parseInt(el.innerHTML.replace(/,/g, ""), 10) !== currentCount) {
        el.innerHTML = currentCount.toLocaleString(); // Format with commas
      }

      if (frame === totalFrames) {
        clearInterval(counter);
      }
    }, frameDuration);
  };

  const countupEl = document.querySelector(".countup");
  animateCountUp(countupEl);

  // END COUNT UP ANIMATION //////////////////////////////////////////////////////////////////////////

  // VIEW ALL MODAL PANEL //////////////////////////////////////////////////////////////////////////

  $(document).on("click", ".view-all-election-modal", function () {
    $(".modal-viewall-panel").removeClass("translate-x-full");
  });

  $("#close-supercycle-viewall-panel").on("click", function () {
    $(".modal-viewall-panel").addClass("translate-x-full");
  });

  $(document).on("click", function (e) {
    if (
      !$(e.target).closest(".modal-viewall-panel").length &&
      !$(e.target).is(".view-all-election-modal")
    ) {
      if (!$(".modal-viewall-panel").hasClass("translate-x-full")) {
        $(".modal-viewall-panel").addClass("translate-x-full");
      }
    }
  });

  // END VIEW ALL MODAL PANEL //////////////////////////////////////////////////////////////////////////

  // HORIZONTAL + VERTICAL BAR CHART
  var win = $(window),
    winHeight = win.height(),
    windowPercentage = winHeight * 0.9;

  function scrollReveal() {
    var scrolled = win.scrollTop();

    // Animate horizontal bars in .chartBarsHorizontal
    $(".chartBarsHorizontal .bar").each(function () {
      var $this = $(this),
        offsetTop = $this.offset().top;

      if (
        (scrolled + windowPercentage > offsetTop || winHeight > offsetTop) &&
        !$this.hasClass("animated")
      ) {
        var percentage = $this.data("percentage");

        // Animate width of the bar
        $this.css("width", percentage + "%");

        // Animate numbers
        $this.prop("Counter", 0).animate(
          { Counter: percentage },
          {
            duration: 2000,
            easing: "swing",
          }
        );

        // Mark as animated
        $this.addClass("animated");
      }
    });

    // Animate elements with .trigger class
    $(".trigger").each(function () {
      var $this = $(this),
        offsetTop = $this.offset().top;

      if (
        (scrolled + windowPercentage > offsetTop || winHeight > offsetTop) &&
        !$this.hasClass("animated")
      ) {
        var percentage = $this.data("percentage");

        // Animate height of the bar
        $this.css("height", percentage + "%");

        // Animate numbers
        $this.prop("Counter", 0).animate(
          { Counter: percentage },
          {
            duration: 2000,
            easing: "swing",
            // step: function (now) {
            //   $this.text(Math.ceil(now));
            // }
          }
        );

        // Mark as animated
        $this.addClass("animated");
      }
    });
  }

  win.on("scroll", scrollReveal);
  scrollReveal();
  // END HORIZONTAL + VERTICAL BAR CHART


  // Unused ////////////////////////////////////////////////////
  $(window).on("scroll", function () {
    return;

    const topSection = $(".top-section");
    const aspectVideo = topSection.find(".aspect-video");
    const middleSection = $(".middle-section");
    const bottomSection = $(".bottom-section");

    // Calculate positions and heights
    const topSectionHeight = topSection.outerHeight();
    const middleSectionHeight = middleSection.outerHeight();

    const topSectionBottom = topSection.offset().top + topSectionHeight;
    const middleSectionTop = middleSection.offset().top;
    const middleSectionBottom = middleSectionTop + middleSectionHeight;
    const bottomSectionTop = bottomSection.offset().top;

    const scrollPosition = $(this).scrollTop() + $(this).height() - 150;

    // console.log("scroll", scrollPosition);
    // console.log("top down", topSectionBottom);
    // console.log("mid top", middleSectionTop);
    // console.log("bottom top", bottomSectionTop);

    if (scrollPosition > middleSectionTop) {
      aspectVideo.css("opacity", 0.2);
    } else {
      aspectVideo.css("opacity", 1);
    }

    if (scrollPosition > bottomSectionTop) {
      middleSection.css("opacity", 0.2);
    } else {
      middleSection.css("opacity", 1);
    }
  });
  // Unused //////////////////////////////////////////////////// END

  // END CANVAS TINY PEOPLE

  // SCARTTED DOT GRAPH
  const positions = {
    yellow: [
      { country: "Belarus", percentage: "33.6%", bottom: 33, left: 62 },
      { country: "Indonesia", percentage: "21%", bottom: 21, left: 53 },
      { country: "Austria", percentage: "36.1%", bottom: 36, left: 85 },
      { country: "Pakistan", percentage: "16.2%", bottom: 17, left: 44 },
      { country: "Japan", percentage: "15.7%", bottom: 16, left: 57 },
    ],
    red: [
      { country: "El Salvador", percentage: "31.7%", bottom: 31, left: 40 },
      { country: "Portugal", percentage: "32.6%", bottom: 32, left: 75 },
      { country: "India", percentage: "13.7%", bottom: 13, left: 48 },
      { country: "Belgium", percentage: "41.3%", bottom: 41, left: 86 },
      { country: "Bulgaria", percentage: "26.7%", bottom: 26, left: 76 },
    ],
    blue: [
      { country: "Solomon Islands", percentage: "6%", bottom: 6, left: 64 },
      { country: "Madagascar", percentage: "16%", bottom: 16, left: 48 },
      { country: "Rwanda", percentage: "63.8%", bottom: 63, left: 36 },
      {
        country: "North Macedonia",
        percentage: "39.2%",
        bottom: 38,
        left: 62,
      },
      { country: "France", percentage: "36.1%", bottom: 36, left: 88 },
    ],
    green: [
      { country: "Mongolia", percentage: "25.4%", bottom: 25, left: 57 },
      { country: "Croatia", percentage: "33.1%", bottom: 33, left: 73 },
      { country: "Jordan", percentage: "19.6%", bottom: 19, left: 47 },
      { country: "Azerbaijan", percentage: "20.8%", bottom: 18, left: 46 },
      { country: "Togo", percentage: "18.6%", bottom: 18, left: 55 },
      { country: "Azerbaijan", percentage: "20.8%", bottom: 20, left: 22 },
      { country: "Republic of Korea", percentage: "20%", bottom: 20, left: 65 },
    ],
    purple: [
      {
        country: "Dominican Republic",
        percentage: "36.8%",
        bottom: 36,
        left: 54,
      },
      { country: "United Kingdom", percentage: "40.5%", bottom: 40, left: 75 },
      { country: "Panama", percentage: "21.4%", bottom: 21, left: 53 },
      { country: "South Africa", percentage: "45.1%", bottom: 45, left: 65 },
      { country: "Bangladesh", percentage: "20%", bottom: 20, left: 45 },
      { country: "Lithuania", percentage: "27.7%", bottom: 27, left: 82 },
    ],
    orange: [
      { country: "Maldives", percentage: "3.2%", bottom: 4, left: 48 },
      { country: "Syria", percentage: "9.6%", bottom: 9, left: 31 },
      { country: "Bhutan", percentage: "4.3%", bottom: 4, left: 58 },
      { country: "Mexico", percentage: "50%", bottom: 50, left: 56 },
      { country: "Taiwan", percentage: "41.6%", bottom: 41, left: 86 },
      { country: "Iran", percentage: "4.8%", bottom: 5, left: 20 },
    ],
  };

  const colors = {
    yellow: "#FFCC5C",
    red: "#DA5D9B",
    blue: "#5383D7",
    orange: "#FF9337",
    green: "#9FEAD8",
    purple: "#665EA6",
  };

  function createDot(color, country, percentage, bottom, left) {
    const dot = $(
      `<div class="dot"><span class="tooltip-info">${country}: ${percentage}</span></div>`
    );
    dot.css({
      bottom: bottom + "%",
      left: left + "%",
      backgroundColor: colors[color],
      opacity: 0,
    });
    $("#graph").append(dot);
  }

  function generateDots() {
    for (const color in positions) {
      positions[color].forEach(({ country, percentage, bottom, left }) => {
        createDot(color, country, percentage, bottom, left);
      });
    }
  }

  generateDots();

  $(".table-of-contents").hide();
  $(".supercycle-page-title-fixed").hide();

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var windowHeight = $(this).height();

    var triggerHeight = $("#graph").offset().top - windowHeight;

    var supercycleContentTop = $(".supercycleContent").offset().top;
    var supercycleContentHeight = $(".supercycleContent").height();
    var supercycleContentBottom =
      supercycleContentTop + supercycleContentHeight - 500;

    // Update the active class on the table of contents
    $(".container[data-title]").each(function () {
      var $section = $(this);
      var sectionTop = $section.offset().top;
      var sectionHeight = $section.outerHeight();

      // Check if the section is in the viewport
      if (
        scrollTop >= sectionTop - windowHeight / 2 &&
        scrollTop < sectionTop + sectionHeight - windowHeight / 2
      ) {
        var sectionTitle = $section.data("title");

        // Update the active class in the table of contents
        $(".table-of-contents .content-list li").removeClass("active");
        $(`.table-of-contents .content-list li`)
          .filter(function () {
            return $(this).text().trim() === sectionTitle;
          })
          .addClass("active");

        // var sectionTitles = [
        //   "Mongolia",
        //   "Age of executive",
        //   "Top 5 most populous countries holding national elections",
        //   "Party Turnover",
        // ];

        // if (sectionTitles.includes(sectionTitle)) {
        //   $(".supercycleContent").addClass("darker-bg");
        // } else {
        //   $(".supercycleContent").removeClass("darker-bg");
        // }
      }
    });

    if (scrollTop > triggerHeight) {
      $(".dot").each(function (index) {
        var $this = $(this);
        setTimeout(function () {
          $this.css("opacity", 1);
        }, index * 100);
      });
    }

    if (
      scrollTop >= supercycleContentTop - 100 &&
      scrollTop <= supercycleContentBottom
    ) {
      $(".table-of-contents").fadeIn();
      $(".supercycle-page-title-fixed").fadeIn();
    } else {
      $(".table-of-contents").fadeOut();
      $(".supercycle-page-title-fixed").fadeOut();
    }
  });

  // END SCARTTED DOT GRAPH

  treemap(Highcharts);

  // Function to create a treemap
  function createTreemap(containerId, data) {
    Highcharts.chart(containerId, {
      chart: {
        type: "treemap",
        width: 160, // Set width
        height: 120, // Set height
        backgroundColor: null, // Remove background color
      },
      title: {
        text: null, // Hide the title
      },
      tooltip: {
        useHTML: true,
        pointFormat: `{point.name}: {point.value}`,
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          data: data,
          borderWidth: 0, // Remove the border around each data point
          dataLabels: {
            enabled: false, // Disable labels on the graphic
          },
        },
      ],
    });
  }

  // Data for each treemap
  const disputedElect = [
    "Opposition boycott",
    "Loser rejected<br/> outcome",
    "Election-related<br/> protests",
    "Instances<br/> of violence",
    "Multiple forms<br/> of dispute",
    "Not disputed",
  ];

  // Africa
  const data1 = [
    {
      name: disputedElect[0],
      // percentage: "23.53%",
      value: 3,
      color: "#36A0E7",
    }, // Boycott
    {
      name: disputedElect[1],
      // percentage: "23.53%",
      value: 2,
      color: "#59E3CA",
    }, // Loser Rejected
    {
      name: disputedElect[2],
      // percentage: "29.41%",
      value: 0,
      color: "#FF9337",
    }, // Protests
    {
      name: disputedElect[3],
      // percentage: "41.18%",
      value: 2,
      color: "#FFCC5C",
    }, // Violence
    {
      name: disputedElect[4],
      // percentage: "36%",
      value: 5,
      color: "#9A98D0",
    }, // Multiple
    { name: disputedElect[5], 
      // percentage: "27%", 
      value: 5, 
      color: "#F9F9FB" }, 
      // None
  ];

  // Americas
  const data2 = [
    {
      name: disputedElect[0],
      // percentage: "0.00%",
      value: 0,
      color: "#36A0E7",
    }, // Boycott
    {
      name: disputedElect[1],
      // percentage: "14.29%",
      value: 0,
      color: "#59E3CA",
    }, // Loser Rejected
    {
      name: disputedElect[2],
      // percentage: "42.86%",
      value: 1,
      color: "#FF9337",
    }, // Protests
    {
      name: disputedElect[3],
      // percentage: "42.86%",
      value: 1,
      color: "#FFCC5C",
    }, // Violence
    {
      name: disputedElect[4],
      // percentage: "33%",
      value: 2,
      color: "#9A98D0",
    }, // Multiple
    { name: disputedElect[5], 
      // percentage: "33%", 
      value: 3, 
      color: "#F9F9FB" }, 
      // None
  ];

  // Asia and the Pacific
  const data3 = [
    {
      name: disputedElect[0],
      // percentage: "5.56%",
      value: 0,
      color: "#36A0E7",
    }, // Boycott
    {
      name: disputedElect[1],
      // percentage: "5.56%",
      value: 0,
      color: "#59E3CA",
    }, // Loser Rejected
    {
      name: disputedElect[2],
      // percentage: "22.22%",
      value: 1,
      color: "#FF9337",
    }, // Protests
    {
      name: disputedElect[3],
      // percentage: "16.67%",
      value: 0,
      color: "#FFCC5C",
    }, // Violence
    {
      name: disputedElect[4],
      // percentage: "18%",
      value: 3,
      color: "#9A98D0",
    }, // Multiple
    { name: disputedElect[5], 
      // percentage: "76%", 
      value: 14, 
      color: "#F9F9FB" }, 
      // None
  ];

  // Europe
  const data4 = [
    {
      name: disputedElect[0],
      // percentage: "11.11%",
      value: 2,
      color: "#36A0E7",
    }, // Boycott
    {
      name: disputedElect[1],
      // percentage: "14.81%",
      value: 0,
      color: "#59E3CA",
    }, // Loser Rejected
    {
      name: disputedElect[2],
      // percentage: "18.52%",
      value: 2,
      color: "#FF9337",
    }, // Protests
    {
      name: disputedElect[3],
      // percentage: "0.00%",
      value: 0,
      color: "#FFCC5C",
    }, // Violence
    {
      name: disputedElect[4],
      // percentage: "14%",
      value: 4,
      color: "#9A98D0",
    }, // Multiple
    {
      name: disputedElect[5],
      // percentage: "67%",
      value: 19,
      color: "#F9F9FB",
    }, // None
  ];

  // West and Central Asia
  const data5 = [
    {
      name: disputedElect[0],
      // percentage: "20%",
      value: 0,
      color: "#36A0E7",
    }, // Boycott
    {
      name: disputedElect[1],
      // percentage: "20%",
      value: 0,
      color: "#59E3CA",
    }, // Loser Rejected
    {
      name: disputedElect[2],
      // percentage: "40%",
      value: 0,
      color: "#FF9337",
    }, // Protests
    {
      name: disputedElect[3],
      // percentage: "0.00%",
      value: 0,
      color: "#FFCC5C",
    }, // Violence
    {
      name: disputedElect[4],
      // percentage: "33%",
      value: 2,
      color: "#9A98D0",
    }, // Multiple
    {
      name: disputedElect[5],
      // percentage: "50.00%",
      value: 3,
      color: "#F9F9FB",
    }, // None
  ];

  // Create each treemap
  createTreemap("treemap1", data1);
  createTreemap("treemap2", data2);
  createTreemap("treemap3", data3);
  createTreemap("treemap4", data4);
  createTreemap("treemap5", data5);
});
